import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataCommon } from '../master-data.common';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-manage-financial-year',
  templateUrl: './manage-financial-year.component.html',
  styleUrls: ['./manage-financial-year.component.css']
})
export class ManageFinancialYearComponent implements OnInit {
  modalFormObjList:any;
  modalForm:any;
  modalStatus:any;
  formSubmitted=false;
  formErrors = MasterDataCommon.financialYearFormErrors;
  formValidationMessages = MasterDataCommon.financialYearFormValidationMessages;

  constructor(private masterDataService:MasterDataService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadFinancialYear();
  }

  loadFinancialYear(){
    this.masterDataService.getFinancialYear()
    .subscribe(res => {
      console.log(res);
      this.modalFormObjList = res;
    });
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      id:[''],
      name :  ['', [Validators.required]],
      startDate :  ['', [Validators.required]],
      endDate :  ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content,status) {
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  onDeleteClick(item){
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
          this.masterDataService.deleteFinancialYear(item.id)
           .subscribe(resp => {
           console.log(resp);
            this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })

  }

  onSaveClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.saveFinancialYear(this.getValueFromModalForm())
      .subscribe(resp => {
        console.log(resp);
        this.closeModal();
        this.changeModalFormObjList(resp);
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
      })
    }
  }

  // ----------------------------
  getValueFromModalForm(){
   var startDate = new Date(this.modalForm.value.startDate.year+'-'+this.modalForm.value.startDate.month+'-'+this.modalForm.value.startDate.day);
   var endDate = new Date(this.modalForm.value.endDate.year+'-'+this.modalForm.value.endDate.month+'-'+this.modalForm.value.endDate.day)

   var jsonValue = {
    id:this.modalForm.value.id,
    name: this.modalForm.value.name,
    startDate:moment(startDate).format("YYYY-MM-DD"),
    endDate:moment(endDate).format("YYYY-MM-DD"),
   }

   return JSON.stringify(jsonValue);

  }

  setValueToModalForm(modalObj){
    console.log(modalObj);
    var startDate = new Date(modalObj.startDate);
    var endDate = new Date(modalObj.endDate);
    var startDate1 = moment(startDate, 'YYYY/MM/DD');
    var endDate1 = moment(endDate, 'YYYY/MM/DD');


    this.modalForm.patchValue({
      id:modalObj.id,
      name: modalObj.name,
      startDate: {year:parseInt(startDate1.format('YYYY')),month:parseInt(startDate1.format('M')),day:parseInt(startDate1.format('D'))},
      endDate: {year:parseInt(endDate1.format('YYYY')),month:parseInt(endDate1.format('M')),day:parseInt(endDate1.format('D'))},

    });

    console.log(this.modalForm.value)
  }


  onEditClick(modalContent,formObj){
    console.log(formObj);
    this.setValueToModalForm(formObj);
    this.openModal(modalContent,'edit');
  }

  onUpdateClick(){
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.updateFinancialYear(this.getValueFromModalForm())
      .subscribe(resp => {
        console.log(resp);
        this.changeModalFormObjList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
      })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj){
    if(this.modalStatus=='add'){
      this.modalFormObjList.push(modalFormObj);
    }
    if(this.modalStatus=='edit'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if(this.modalStatus=='delete'){
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }


  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
